import { AUTH, LOGOUT, UPDATE_SUCCESS, DELETE, RESET_PASSWORD_FAIL, RESET_PASSWORD_SUCCESS } from '../constants/actionTypes.js';
import * as api from '../api/index.js';
import axios from 'axios';

export function logout() {
    return async (dispatch) => {
        await api.logOut();
        dispatch({ type: LOGOUT });
    }
}
export const signin = (formData, navigate) => async (dispatch) => {
    try {
        const { data } = await api.signIn(formData);
        dispatch({ type: AUTH, data });
        if (data.result.roleType === "Admin") {
            navigate('/adminHome');
        } else if (data.result.roleType === "User") {
            navigate('/userHome');
        } else {
            navigate('/');
        }
        // Refresh the page to apply changes
        window.location.reload();
    } catch (err) {
        console.error("Sign In Error:", err.response?.data?.message || err.message);
        throw new Error(err.response?.data?.message || "Sign In failed. Please try again.");
    }
}
export const signup = (formData, navigate) => async (dispatch) => {
    try {
        const { data } = await api.signUp(formData);

        if (data.status === 'email_taken' || data.status === 'username_taken') {
            return {
                data: {
                    status: data.status,
                    message: data.message ||
                        (data.status === 'email_taken'
                            ? "Email already in use."
                            : "Username already taken.")
                }
            };
        }

        if (data.users) {
            // dispatch({ type: AUTH, data });
            return { data: { status: "success", users: data.users } };
        }

        throw new Error("Unexpected response from server. Please try again.");
    } catch (err) {
        if (err.response?.status === 409) {
            return { data: err.response.data };
        }
        console.error("Sign Up Error:", err.response?.data?.message || err.message);
        throw new Error(err.response?.data?.message || "Sign Up failed. Please try again.");
    }
}
export const updateProfile = (userId, formData, navigate) => async (dispatch) => {
    try {
        const { data } = await api.updateProfile(userId, formData);
        dispatch({ type: UPDATE_SUCCESS });
        navigate('/userControlPanel');
        return data;
    } catch (err) {
        console.error("Update Profile Data Error:", err.response?.data?.message || err.message);
        throw new Error(err.response?.data?.message || "Update profile failed. Please try again.");
    }
}

export const resetPassword = (token, newPassword, navigate) => async (dispatch) => {
    try {
        const { data } = await api.resetPassword(token, newPassword);
        dispatch({ type: 'RESET_PASSWORD_SUCCESS', payload: data });
        alert('Password reset successful! You can now sign in with your new password.');
        navigate('/authorization'); // Redirect to login page after successful reset
    } catch (error) {
        const errorMessage = error.response?.data || 'Password reset failed. The link may have expired.';
        alert(errorMessage);
        dispatch({ type: 'RESET_PASSWORD_FAIL', payload: error.response?.data });
    }
};

export const deleteMyAccount = (id) => async (dispatch) => {
    try {
        const { data } = await api.deleteUser(`${id}`);

        if (data.success) {
            dispatch({ type: DELETE });
            localStorage.clear();
            //    window.location.href = "/login";
            return {
                success: true,
                message: data.message || 'Account deleted successfully',
                data: data.data
            };
        } else {
            return {
                payload: {
                    success: false,
                    message: data.message || 'Deletion failed',
                    isNotFound: data.message === 'User not found'
                }
            };
        }
    } catch (err) {
        console.error("Delete error:", err);
        return {
            success: false,
            message: err.response?.data?.message || 'Failed to delete account',
            isNetworkError: !err.response
        };
    }
};